export const matchFromUrl = (str) => {
  var reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
  var url = str.match(reg)
  if (url) {
    str = str.replace(reg, '<a href=' + url[0] + ' target="_blank">' + url[0] + '</a>')
  }
  return str
}
